module.exports = __webpack_public_path__ + "static/media/9_nine_Severe.03ec31f7.svg";